import { render, staticRenderFns } from "./text-description.vue?vue&type=template&id=42732c77&"
import script from "./text-description.vue?vue&type=script&lang=js&"
export * from "./text-description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports